import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

const MOUDetailsTable = () => {
  const [mouDetails, setMouDetails] = useState(null); // State for storing MOU details

  // Fetch MOU details on component load
  useEffect(() => {
    const mouid = localStorage.getItem("mouidd") // Replace with your actual MOU ID if needed
    fetchMouDetails(mouid); // Fetch details based on MOU ID
  }, []);

  // Function to fetch MOU details from backend using GET request
  const fetchMouDetails = async (mouid) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/mou-renewals/mou/${mouid}`
      );
      const data = response.data;

      if (Array.isArray(data)) {
        setMouDetails(data); // Set MOU details for table display
      } else {
        setMouDetails([]); // No MOU details found
      }
    } catch (error) {
      console.error("Error fetching MOU details:", error);
      Swal.fire({
        icon: "error",
        title: "Error Fetching Data",
        text: "Failed to retrieve MOU details.",
      });
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">MOU Details</h2>
      <div
        className="table-responsive shadow bg-white rounded"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        {mouDetails && mouDetails.length > 0 ? (
          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th>MOU ID</th>
                <th>Date of Renewal</th>
                <th>Date of End</th>
                <th>File Name</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {mouDetails.map((mou, index) => (
                <tr key={index}>
                  <td>{mou[1]}</td> {/* MOU ID */}
                  <td>{mou[0].split("T")[0]}</td> {/* Date of Renewal */}
                  <td>{mou[2]}</td> {/* Date of End */}
                  <td>{mou[3]}</td> {/* File Name */}
                  <td>
                    <a
                      href={`${process.env.REACT_APP_FILE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.comloudflare.com'}/uploads/${mou[3]}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Document
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No MOU details found.</p>
        )}
      </div>
    </div>
  );
};

export default MOUDetailsTable;
